import React from 'react';

/**
 * The four MUI icon glyphs the portal-owned UI renders, as plain SVGs with
 * MUI's own path data (copied from @mui/icons-material), so dropping the MUI
 * runtime changes nothing on screen. Same box as MUI's SvgIcon: 24px viewBox,
 * 1em sizing at 24px font-size, currentColor fill.
 */

type IconProps = React.SVGProps<SVGSVGElement>;

const svgIconStyle: React.CSSProperties = {
  width: '1em',
  height: '1em',
  fontSize: '24px',
  fill: 'currentColor',
  flexShrink: 0,
  display: 'inline-block',
};

const createIcon = (path: string, name: string): React.FC<IconProps> => {
  const Icon: React.FC<IconProps> = ({ style, ...props }) => (
    <svg
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      style={{ ...svgIconStyle, ...style }}
      {...props}
    >
      <path d={path} />
    </svg>
  );
  Icon.displayName = `${name}Icon`;
  return Icon;
};

export const CloseIcon = createIcon(
  'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
  'Close'
);

export const MoreVertIcon = createIcon(
  'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2',
  'MoreVert'
);

export const IosShareIcon = createIcon(
  'm16 5-1.42 1.42-1.59-1.59V16h-1.98V4.83L9.42 6.42 8 5l4-4zm4 5v11c0 1.1-.9 2-2 2H6c-1.11 0-2-.9-2-2V10c0-1.11.89-2 2-2h3v2H6v11h12V10h-3V8h3c1.1 0 2 .89 2 2',
  'IosShare'
);

export const AddCircleOutlineIcon = createIcon(
  'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8',
  'AddCircleOutline'
);
